import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import getCookie from "../getCookie";
import Redirect from "react-router-dom/Redirect";
import moment from 'moment'

// React components
import * as Yup from "yup";
import { Formik } from "formik";
import axios from "axios"

const initialvals = {
                organization: "",
                validity: "",
                nextCheckDate:"",
                camera_limit: "",
                number_of_usecases_per_camera: "",
                usecases: {},
                features: { pms: false, face: false },
                vast_id: "",
                otp: "",
                mail: ""
              }


export class GenerateKeyV2 extends Component {
  state = { 
    copied: false,
    selectedCheckpointTypes: [],
    checkpoint_type_list_config: [],
    prevLicDetails:initialvals,
    loading:true
  };

  componentDidMount(){
    this.initializeData()
  }

  initializeData = async () => {
    try {
      this.setState({loading:true})
      // Always fetch checkpoint type list
      await this.getCheckpointTypeList()
      
      // If editing, also fetch license details
      if(this.props.isEdit){
        await this.get_lic_details()
      }
      
      // Set loading to false only after all required data is fetched
      this.setState({loading:false})
    } catch (error) {
      console.error("Error initializing data:", error)
      this.setState({loading:false})
    }
  }
  
  get_lic_details = async () => {
    let response = await axios.get(`license/get-lic-details/?vast_id=${this.props.vast_id}`)
    let lic_details = {}
    response = response.data.data
    console.log("response ",response)
    const licJson = response.lic_json || {}
    lic_details['organization'] = response.organization
    lic_details['validity'] = moment(response.validity).format('YYYY-MM-DD')
    lic_details['nextCheckDate'] = moment(response.nextCheckDate).format('YYYY-MM-DD')
    lic_details['number_of_usecases_per_camera'] = licJson['number_of_usecases_per_camera']
    lic_details['camera_limit'] = licJson['number_of_cameras']
    lic_details['vast_id'] = response.vast_id
    if(licJson.hasOwnProperty('usecases')){
        // license generated after the usecases/features split
        lic_details['usecases'] = licJson['usecases'] || {}
        lic_details['features'] = licJson['features'] || { pms: false, face: false }
    } else {
        // legacy license: 'features' held the usecase counts, no boolean feature flags existed
        lic_details['usecases'] = licJson['features'] || {}
        lic_details['features'] = { pms: false, face: false }
    }
    console.log("lic_details ",lic_details)

    this.setState({prevLicDetails:lic_details})
  }

  getCheckpointTypeList = async () => {
    try {
      const token = window.localStorage.getItem("token");
      const csrfToken = getCookie("csrftoken");
      const response = await fetch("/license/get-checkpointtype-list/", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrfToken,
          Authorization: `Token ${token}`,
        },
      });
      const data = await response.json();
      if (data.success && Array.isArray(data.Data)) {
        this.setState({ checkpoint_type_list_config: data.Data });
      }
    } catch (error) {
      console.error("Failed to fetch checkpoint type list:", error);
    }
  }

  copyToClickboard = (e) => {
    window.getSelection().removeAllRanges();
    var range = document.createRange();
    range.selectNode(e.target.parentElement.parentElement.firstChild);
    window.getSelection().addRange(range);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
    this.setState({copied: true})
    setTimeout(()=>{
      this.setState({copied: false})
    }, 2000)
  };

  // handleCheckpointToggle = (checkpointValue) => {
  // Toggle checkpoint: add with count 1 if not present, remove if present
  handleCheckpointToggle = (checkpoint, values, setFieldValue) => {
    const usecases = { ...values.usecases };
    if (usecases.hasOwnProperty(checkpoint)) {
      delete usecases[checkpoint];
    } else {
      usecases[checkpoint] = 1;
    }
    setFieldValue("usecases", usecases);
  };

  // Increase count for a checkpoint
  handleIncrement = (checkpoint, values, setFieldValue) => {
    const usecases = { ...values.usecases };
    if (usecases.hasOwnProperty(checkpoint)) {
      usecases[checkpoint] = usecases[checkpoint] + 1;
      setFieldValue("usecases", usecases);
    }
  };

  // Decrease count for a checkpoint, not below 0
  handleDecrement = (checkpoint, values, setFieldValue) => {
    if (values.usecases[checkpoint] === 1) return;
    const usecases = { ...values.usecases };
    if (usecases.hasOwnProperty(checkpoint) && usecases[checkpoint] > 0) {
      usecases[checkpoint] = usecases[checkpoint] - 1;
      setFieldValue("usecases", usecases);
    }
  };

  handleSelectAllUseCase = (selectAll, values, setFieldValue) => {
    if (selectAll) {
      const all = {};
      this.state.checkpoint_type_list_config.forEach(item => {
        all[item.value] = 1;
      });
      setFieldValue("usecases", all);
    } else {
      setFieldValue("usecases", {});
    }
  };

  // Toggle a boolean feature flag (e.g. pms, face)
  handleFeatureToggle = (featureKey, values, setFieldValue) => {
    setFieldValue(`features.${featureKey}`, !values.features[featureKey]);
  };

  handleGenerateKeySubmit = (values, setSubmitting, setValues) => {
    const token = window.localStorage.getItem("token");
    const csrfToken = getCookie("csrftoken");
    const { organization, validity, nextCheckDate, vast_id, camera_limit, number_of_usecases_per_camera, usecases, features } = values;
    const data = {
      organization,
      validity,
      nextCheckDate,
      // permanent,
      vast_id: vast_id,
      usecases, // send the usecase-count dict
      features, // send the boolean feature flags
      camera_limit,
      number_of_usecases_per_camera
    }
    fetch(`/license/generatekey-v2/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        setSubmitting(false)
        if (response.success) {
          setValues({ ...values, otp: response.OTP, mail: 'mailto:?subject=VAST%20OTP&body=' + response.OTP })
        }
      })
      .catch((error) =>{
        console.error(error)
        setSubmitting(false)
      } );
        
  };
  
  errorMsg= (errors) => {
    let errorMsg = `Required, Please fill${errors.organization || ""}${errors.validity || ""}${errors.nextCheckDate || ""}${errors. vast_id || ""}${errors.camera_limit || ""}${errors.usecases || ""}${errors.number_of_usecases_per_camera || ""}`
    errorMsg = `${errorMsg.substring(0, errorMsg.length - 1)}.`
    return errorMsg
  }

  handleCloseModal = () => {
    this.props.handleCloseModal();
  };

  render() {
    const { selectedCheckpointTypes } = this.state;
    const isAllSelected = selectedCheckpointTypes.length === this.state.checkpoint_type_list_config.length;
    const selectedUseCases = this.state.checkpoint_type_list_config.filter(item => 
      selectedCheckpointTypes.includes(item.value)
    );

    return (
      <div style={{ width: "100%" }}>
        {this.props.open && (
            <div 
              className="modal-backdrop fade show"
              style={{ display: 'block' }}
            />
          )}
        <div
          className={`modal fade ${this.props.open ? 'show' : ''}`}
          id="genrate_key_modalv2"
          style={{ width: "100%", display: this.props.open ? 'block' : 'none' }}
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ 
              maxWidth: "1280px", 
              width: "90vw", 
              // margin: "30px auto",
              // height: "calc(100vh - 60px)"
            }}
          >
            <Formik
              initialValues={this.props.isEdit?this.state.prevLicDetails:initialvals}
              enableReinitialize={true}
              validationSchema={Yup.object().shape({
                organization: Yup.string().required(" Organization name,"),
                vast_id: Yup.string().required(" VastID,"),
                nextCheckDate:Yup.string().required(" Next Check Date"),
                camera_limit: Yup.number().moreThan(0, 'Must be greater than 0').required(" Number of cameras"),
                number_of_usecases_per_camera: Yup.number().moreThan(0, 'Must be greater than 0').required(" Number of UseCases per camera"),
                usecases: Yup.object().test('has-at-least-one', ' At least one checkpointType is required', value => value && Object.keys(value).length > 0)
              })}
              validateOnChange={false}
              onSubmit={(values, { setSubmitting, setValues }) => {
                this.handleGenerateKeySubmit(values, setSubmitting, setValues);
              }}
            >
              {({
                values,
                errors,
                isValidating,
                isSubmitting,
                handleChange,
                handleSubmit,
                resetForm,
                setFieldValue,
              }) => (
                <form onSubmit={handleSubmit} style={{ height: "100%" }}>
                  <div className="modal-content" style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    {/* Header */}
                    <div className="modal-header" style={{ flexShrink: 0, padding: "1rem 1.5rem" }}>
                      <h4 className="mb-0">Generate License Key</h4>
                      <button
                        type="button"
                        className="close"
                        aria-label="Close"
                        onClick={() => {
                          resetForm();
                          this.handleCloseModal();
                        }}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    {/* Body with two columns */}
                    <div className="modal-body" style={{ 
                      flex: 1, 
                      overflow: "hidden", 
                      padding: 0,
                      display: "flex"
                    }}>
                      {/* Left Column - Form Details */}
                      <div style={{ 
                        width: "30%", 
                        borderRight: "2px solid #dee2e6",
                        backgroundColor: "#f8f9fa"
                      }}>
                        <div style={{ 
                            padding: "10px", 
                            backgroundColor: "#e9ecef", 
                            borderBottom: "1px solid #dee2e6",
                            flexShrink: 0,
                            height:"70px"
                          }}>
                            <h5 className="mb-0" style={{ color: "#495057", fontWeight: "600" }}>License Details</h5>
                        </div>
                      <div style={{ 
                        width: "100%", 
                        padding: "10px", 
                        backgroundColor: "#f8f9fa"
                      }}>
                        <div className="form-group mb-2 d-flex flex-column align-items-start">
                          <label style={{ fontWeight: "500" }}>Organization</label>
                          <input
                            name="organization"
                            className="form-control"
                            type="text"
                            placeholder="Enter Organization Name"
                            onChange={handleChange}
                            value={values.organization}
                            style={{ padding: "5px", fontSize: "16px" }}
                          />
                        </div>

                        <div className="form-group mb-2 d-flex flex-column align-items-start">
                          <div className="w-100 row">
                            <label className="col-6 text-left" style={{ fontWeight: "500" }}>Expiration Date</label>
                            <label className="col-6 text-left" style={{ fontWeight: "500" }}>Next Check Date</label>
                          </div>
                          <div className="w-100 row">
                            <div className="col-6">
                              <input
                                name="validity"
                                className="form-control"
                                type="date"
                                min={moment(new Date()).format('YYYY-MM-DD')}
                                onChange={handleChange}
                                value={values.validity}
                                style={{ padding: "10px", fontSize: "16px" }}
                              />
                            </div>
                            <div className="col-6">
                              <input
                                name="nextCheckDate"
                                className="form-control"
                                type="date"
                                min={moment(new Date()).format('YYYY-MM-DD')}
                                onChange={handleChange}
                                value={values.nextCheckDate}
                                style={{ padding: "10px", fontSize: "16px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="form-group mb-2 d-flex flex-column align-items-start">
                          <label style={{ fontWeight: "500" }}>Vast ID</label>
                          <input
                            name="vast_id"
                            className="form-control"
                            type="text"
                            onChange={handleChange}
                            placeholder="Enter VastID"
                            value={values.vast_id}
                            style={{ padding: "10px", fontSize: "16px" }}
                          />
                        </div>

                        <div className="form-group mb-2 d-flex flex-column align-items-start">
                          <label style={{ fontWeight: "500" }}>Number of cameras</label>
                          <input
                            name="camera_limit"
                            className="form-control"
                            type="number"
                            min={0}
                            placeholder="Enter number of cameras"
                            onChange={handleChange}
                            value={values.camera_limit}
                            style={{ padding: "10px", fontSize: "16px" }}
                          />
                        </div>
                        <div className="form-group mb-2 d-flex flex-column align-items-start">
                          <label style={{ fontWeight: "500" }}>Number of usecases per camera</label>
                          <input
                            name="number_of_usecases_per_camera"
                            className="form-control"
                            type="number"
                            min={0}
                            placeholder="Enter number of UseCases per camera"
                            onChange={handleChange}
                            value={values.number_of_usecases_per_camera}
                            style={{ padding: "10px", fontSize: "16px" }}
                          />
                        </div>

                        {values.otp && (
                          <div className="form-group mb-2 d-flex flex-column align-items-start">
                            <label style={{ fontWeight: "500" }}>Generated OTP</label>
                            <div className="d-flex align-items-center p-3 bg-success text-white rounded">
                              <span className="mr-3" style={{ fontSize: "16px", fontWeight: "bold" }}>{values.otp}</span>
                              <span
                                onClick={(e) => this.copyToClickboard(e)}
                                style={{ cursor: "pointer", marginRight: '15px' }}
                                title="Copy OTP"
                              >
                                <img src="https://img.icons8.com/carbon-copy/24/ffffff/copy.png" alt="Copy" />
                              </span>
                              <a href={values.mail} title="Send via Email">
                                <img src="https://img.icons8.com/wired/24/ffffff/email.png" alt="Email" />
                              </a>
                            </div>
                            <small className="text-success mt-2 d-block">
                              OTP generated successfully! Please reset before generating a new OTP.
                            </small>
                          </div>
                        )}

                        {(errors.organization || errors.validity || errors.nextCheckDate || errors.vast_id || errors.camera_limit || errors.usecases) && (
                          <div className="alert alert-danger" style={{ fontSize: "16px" }}>
                            {this.errorMsg(errors)}
                          </div>
                        )}
                      </div>
                      </div>

                      {/* Right Column - Checkpoint Selection */}
                      <div style={{ 
                        width: "70%", 
                        display: "flex", 
                        // flexDirection: "column",
                        backgroundColor: "#ffffff"
                      }}>
                        {/* Available UseCases */}
                        <div style={{
                          // height: "48%"
                          width:"40%",
                          display: "flex",
                          flexDirection: "column",
                          borderBottom: "2px solid #dee2e6"
                        }}>
                          <div style={{ 
                            padding: "10px", 
                            backgroundColor: "#e9ecef", 
                            borderBottom: "1px solid #dee2e6",
                            flexShrink: 0,
                            height:"70px"
                          }}>
                            <h6 className="mb-2" style={{ color: "#495057", fontWeight: "600" }}>Available UseCases</h6>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                style={{
                                  cursor: "pointer",
                                  // marginRight: "14px", // add space between checkbox and label
                                  width: "20px",
                                  height: "20px"
                                }}
                                checked={Object.keys(values.usecases).length === this.state.checkpoint_type_list_config.length}
                                onChange={(e) => this.handleSelectAllUseCase(e.target.checked, values, setFieldValue)}
                                id="selectAllUseCases"
                              />
                              <label className="form-check-label ml-1" htmlFor="selectAllUseCases" style={{ fontWeight: "500" }}>
                                Select All ({this.state.checkpoint_type_list_config.length} items)
                              </label>
                            </div>
                          </div>
                          <div style={{ 
                            flex: 1, 
                            overflowY: "auto", 
                            // padding: "15px 30px"
                            padding: "0px 10px 0px 10px"
                            }}>
                            <div className="d-flex flex-column justify-content-start align-items-start" style={{maxHeight:"480px",width:"100%",overflowY:"auto"}}>
                              {this.state.checkpoint_type_list_config.map((checkpoint, index) => (
                              <div 
                                key={index} 
                                className="form-check d-flex justify-content-start align-items-center w-100" 
                                style={{
                                padding: "10px 30px", // increased vertical padding
                                backgroundColor: "aliceblue",
                                marginTop: "10px",
                                borderRadius: "4px"
                                }}
                              >
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  style={{
                                    cursor: "pointer",
                                    marginRight: "14px", // add space between checkbox and label
                                    width: "20px",
                                    height: "20px"
                                  }}
                                  checked={values.usecases.hasOwnProperty(checkpoint.value)}
                                  onChange={() => this.handleCheckpointToggle(checkpoint.value, values, setFieldValue)}
                                  id={`checkpoint_${index}`}
                                />
                                <label 
                                  className="form-check-label" 
                                  htmlFor={`checkpoint_${index}`} 
                                  style={{
                                    cursor: "pointer", 
                                    fontSize: "18px",
                                    paddingLeft: "4px" // extra space for label
                                  }}
                                >
                                {checkpoint.value}
                                </label>
                              </div>
                              ))}
                            </div>
                            </div>
                          </div>

                          {/* Selected UseCases */}
                        <div style={{
                          // height: "48%",
                          width:"35%",
                          display: "flex",
                          flexDirection: "column",
                          borderRight: "2px solid #dee2e6"
                        }}>
                          <div style={{ 
                            // padding: "20px 30px 15px", 
                            padding:'10px',
                            height:"70px",
                            backgroundColor: "#d4edda",
                            flexShrink: 0
                          }}>
                            <h6 className="mb-1" style={{ color: "#155724", fontWeight: "600" }}>
                              Selected UseCases ({Object.entries(values.usecases).length})
                            </h6>
                          </div>
                          <div style={{
                            flex: 1,
                            overflowY: "auto",
                            padding: "0px 10px 0px 10px",
                          }}>
                            {Object.keys(values.usecases).length === 0 ? (
                              <div className="text-center py-4">
                                <p className="text-muted">No UseCase selected yet</p>
                                <small className="text-muted">Select from the available UseCases above</small>
                              </div>
                            ) : (
                              <div className="d-flex flex-column justify-content-start align-items-start" style={{maxHeight:"480px",width:"100%",overflowY:"auto"}}>
                                {Object.entries(values.usecases).map(([checkpoint, count], index) => (
                                  <div key={checkpoint} className="d-flex flex-column bg-light rounded border w-100" style={{ padding:"8px 10px",backgroundColor:"aliceblue",marginTop:"10px"}}>
                                    <div className="d-flex justify-content-between align-items-start w-100">
                                      <span style={{fontSize: "16px", textAlign: "left", wordBreak: "break-word", flex: 1, marginRight: "8px"}}>{checkpoint}</span>
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() => this.handleCheckpointToggle(checkpoint, values, setFieldValue)}
                                        style={{ fontSize: "18px",cursor:"pointer", padding: "2px 6px", lineHeight: "1", flexShrink: 0 }}
                                        title="Remove checkpoint"
                                      >
                                        ×
                                      </button>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-start" style={{ marginTop: "8px" }}>
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={() => this.handleDecrement(checkpoint, values, setFieldValue)}
                                        style={{ fontSize: "18px",cursor:"pointer", padding: "2px 8px", marginRight: "5px" }}
                                        title="Decrease count"
                                        disabled={count === 0}
                                      >
                                        -
                                      </button>
                                      <input
                                        type="number"
                                        value={count}
                                        minValue={1}
                                        onChange={(e) => setFieldValue(`usecases.${checkpoint}`, parseInt(e.target.value) || 1)}
                                        className="form-control form-control-sm"
                                        style={{ width: "60px", textAlign: "center" }}
                                      />
                                      {/* <span style={{fontSize: "18px", minWidth: "24px", textAlign: "center"}}>{count}</span> */}
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={() => this.handleIncrement(checkpoint, values, setFieldValue)}
                                        style={{ fontSize: "18px",cursor:"pointer", padding: "2px 8px", marginLeft: "5px" }}
                                        title="Increase count"
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Features */}
                        <div style={{
                          width:"25%",
                          display: "flex",
                          flexDirection: "column"
                        }}>
                          <div style={{
                            padding: "10px",
                            backgroundColor: "#e9ecef",
                            borderBottom: "1px solid #dee2e6",
                            flexShrink: 0,
                            height:"70px"
                          }}>
                            <h6 className="mb-0" style={{ color: "#495057", fontWeight: "600" }}>Features</h6>
                          </div>
                          <div style={{
                            flex: 1,
                            overflowY: "auto",
                            padding: "10px"
                          }}>
                            {[
                              { key: "pms", label: "Parking Management" },
                              { key: "face", label: "Face" },
                            ].map(({ key, label }) => (
                              <div
                                key={key}
                                className="d-flex justify-content-between align-items-center w-100"
                                style={{
                                  padding: "10px",
                                  backgroundColor: "aliceblue",
                                  marginTop: "10px",
                                  borderRadius: "4px"
                                }}
                              >
                                <label className="mb-0" style={{ fontSize: "16px", cursor: "pointer", textAlign: "left", wordBreak: "break-word", flex: 1, marginRight: "8px" }} htmlFor={`feature_${key}`}>
                                  {label}
                                </label>
                                <div className="custom-control custom-switch" style={{ flexShrink: 0 }}>
                                  <input
                                    type="checkbox"
                                    style={{ cursor: "pointer" }}
                                    className="custom-control-input"
                                    id={`feature_${key}`}
                                    checked={!!values.features[key]}
                                    onChange={() => this.handleFeatureToggle(key, values, setFieldValue)}
                                  />
                                  <label className="custom-control-label" htmlFor={`feature_${key}`}></label>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Footer with buttons */}
                    <div className="modal-footer" style={{ flexShrink: 0, padding: "10px" }}>
                      <button
                        className="btn btn-secondary btn"
                        type="button"
                        onClick={() => {
                          resetForm();
                          // this.setState({ selectedCheckpointTypes: [] });
                        }}
                        style={{ minWidth: "120px" }}
                      >
                        Reset All
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary btn"
                        disabled={isValidating || isSubmitting || values.otp}
                        style={{ minWidth: "150px" }}
                      >
                        {isSubmitting ? "Generating..." : "Generate Key"}
                      </button>
                    </div>

                    {this.state.copied && (
                      <div style={{
                        position: 'absolute', 
                        top: '15px', 
                        right: '15px',
                        padding: '10px 15px', 
                        color: 'white', 
                        backgroundColor: '#28a745',
                        borderRadius: '5px',
                        zIndex: 1000,
                        fontSize: '14px',
                        fontWeight: '500'
                      }}>
                        Copied to clipboard!
                      </div>
                    )}
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(GenerateKeyV2);